import React from 'react';
import { useModal } from "./templating/modal";

interface IProps {
    confirmationText: string;
    closeModal: (response: boolean) => void;
}

const ConfirmationModal: React.FC<IProps> = ({ confirmationText, closeModal }) => {

    function handleYes() {
        closeModal(true);
    }

    function handleNo() {
        closeModal(false);
    }

    const Content: React.FC = () => {
        return (
            <div className="w-1/2 mx-auto border border-gray-800">
                <div className='px-5 py-2 bg-br-blue-300'>
                    <div>
                        <h1 className="text-4xl md:text-6xl font-thin text-center pb-1 pt-3">Are you sure?</h1>
                        <hr className="mx-auto mt-3" />

                        <div className="py-2">
                            <div className="text-base text-center">
                                {confirmationText}
                            </div>
                            <div className="flex justify-center pt-2">
                                <button className="bg-green-500 hover:birghtness-110 px-5 py-1 mr-1 border-gray-700 border" onClick={handleYes}>Yes</button>
                                <button className="bg-red-600 hover:birghtness-110 px-5 py-1 ml-1 border-gray-700 border" onClick={handleNo}>No</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
        )
    }

    const Modal = useModal(<Content />);

    return (
        <Modal.ModalContent />
    );
}

export default ConfirmationModal;